import { ky } from './ky';
import { ExistResponse } from './common';

export default class FeedLikeService {

  /**
   * 피드 좋아요 추가
   *
   * @param feedId 피드 ID
   */
  async like(feedId: string) {
    await ky.post(`v1/feeds/${feedId}/likes`);
  }

  /**
   * 피드 좋아요 취소
   *
   * @param feedId 피드 ID
   */
  async unlike(feedId: string) {
    await ky.delete(`v1/feeds/${feedId}/likes`);
  }

  /**
   * 피드 좋아요 여부 가져오기
   *
   * @param feedId 피드 ID
   */
  async exists(feedId: string) {
    return await ky.get(`v1/feeds/${feedId}/likes`).json() as ExistResponse;
  }

}
